export default "__VITE_ASSET__B8wJIQ14__"